export const ACOMPANHAMENTO_OFICINA = () => `/acompanhamento-oficina`;
